<h2 class="filters-space" i18n="@@registration-codes.registration_code">Kod rejestracyjny</h2>
<div class="header-buttons">
  <div class="l-row">
    <div class="l-col l-col--20">
      <label class="o-form-label"
             i18n="@@registration.current_registration_code"
      >Aktualny kod rejestracyjny</label>
      <input
        class="o-form-field"
        type="text"
        [readonly]="readonly"
        [value]="currentCode?.code"
      >
    </div>
    <div class="l-col l-col--50 l-col--bottom">
      <div class="l-row">
        <div class="l-col">
          <button
            class="o-btn o-btn--primary"
            (click)="this.generateNewCode()"
            [disabled]="!(canGenerateNewCode$ | async)"
            i18n="@@registration-codes.generate_new_code"
          >Generuj nowy kod</button>
        </div>
      </div>
    </div>
  </div>
</div>

<pseic-form-field
  label="Historia najnowszych kodów rejestracyjnych"
  i18n-label="@@registration-codes.history_registration_codes"
>
</pseic-form-field>

<div class="pseic-table-content">
  <table class="o-simple-table u-width-500">
    <thead>
    <tr>
      <th i18n="@@common.actions">Akcje</th>
      <th i18n="@@registration-codes.registration_code">Kod rejestracyjny</th>
      <th i18n="@@registration-codes.generation_date">Data generacji</th>
      <th i18n="@@registration-codes.expiration_date">Data ważności</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of registrationCodes$ | async; trackBy:trackById">
      <td class="psei-data-td-actions">
        <div class="psei-data-table__row-icons">
          <psei-button
            [disabled]="item.active === 'false'"
            [tile]="true"
            icon="circle-dismiss"
            [color]="'negative'"
            [pseiTooltip]="invalidateTooltip"
            (buttonClick)="deactivateCode(item)"
          ></psei-button>
        </div>
      </td>
      <td class="table-number table-actions">{{ item.code }}</td>
      <td class="table-date">{{ item.generationDate | date:'yyyy-MM-dd HH:mm:ss' }}</td>
      <td class="table-date">{{ item.expirationDate | date:'yyyy-MM-dd HH:mm:ss' }}</td>
    </tr>
    </tbody>
  </table>
</div>
